<!-- Created by henian.xu on 2021/7/16. -->

<template>
    <div class="monitor-map">
        <!--    &#45;&#45;{{ lushuPlay }}&#45;&#45; &#45;&#45;{{ lushuPath.length }}&#45;&#45; &#45;&#45;{{ speed }}&#45;&#45;-->
        <baidu-map
            class="map"
            :center="centerLatLng"
            :zoom="zoom"
            :scroll-wheel-zoom="true"
            :map-click="false"
            @ready="onMapReady"
        >
            <bm-control class="bm-control">
                <div class="left-wrap">
                    <BMapDrawingManager
                        ref="bMapDrawingManager"
                        v-if="!!showDrawingManager"
                        :show-type="showDrawingManager"
                        :enable-editing="drawingManagerEnableEditing"
                    ></BMapDrawingManager>
                </div>
                <div class="right-wrap">
                    <BMapDistanceTool v-if="showDistanceTool"></BMapDistanceTool>
                </div>
            </bm-control>
            <bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :show-address-bar="true"
                :auto-location="true"
            />
            <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
            <bm-navigation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :offset="{ width: -10, height: 80 }"
            ></bm-navigation>
            <!--      <bm-map-type
        :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
        anchor="BMAP_ANCHOR_BOTTOM_LEFT"
        :offset="{ width: 10, height: 60 }"
      ></bm-map-type>-->
            <!-- ----------- -->
            <bml-lushu
                v-if="hasLushu"
                @start="changeBtnText('pause')"
                @stop="changeBtnText('play_arrow')"
                @pause="changeBtnText('play_arrow')"
                :path="lushuPath"
                :rotation="true"
                :speed="speed"
                :auto-view="autoView"
                :icon="lushuPathIcon"
                :play="lushuPlay"
            >
            </bml-lushu>
            <bml-marker-clusterer :average-center="true">
                <bm-marker
                    v-for="(marker, index) of vehicleMarkers"
                    :key="index"
                    :position="{ lng: marker.longitude, lat: marker.latitude }"
                    :icon="marker.icon"
                    :rotation="marker.rotation"
                    @click="onMarker(marker, index)"
                >
                    <bm-info-window
                        v-if="marker.infoWindowData"
                        :show="marker.infoWindowShow"
                        @close="onMarker(marker, index, false)"
                        @open="onMarker(marker, index, true)"
                    >
                        <InfoWindow :dataset="marker.infoWindowData"></InfoWindow>
                    </bm-info-window>
                </bm-marker>
            </bml-marker-clusterer>
        </baidu-map>
        <!--    <el-button @click="toggle">{{ lushuPlay ? '结束' : '开始' }}</el-button>-->
    </div>
</template>

<script>
import { BmlLushu, BmlMarkerClusterer } from 'vue-baidu-map';
import coordtransform from 'coordtransform';
import { Utils } from 'vmf';
import InfoWindow from './_infoWindow';
import BMapDistanceTool from './_BMapDistanceTool';
import BMapDrawingManager from './_BMapDrawingManager';
import vehicleIcon from './vehicle-icon.png';

export default {
    name: 'MonitorMap',
    components: {
        BMapDrawingManager,
        BMapDistanceTool,
        InfoWindow,
        BmlLushu,
        BmlMarkerClusterer,
    },
    data() {
        return {
            BMap: null,
            map: null,
            /* centerLatLng: {
        // lng: 118.620816,
        // lat: 24.890417,
        lng: 118.865842,
        lat: 25.169908,
      }, */
            fly:
                'data:image/png;base64,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',
            lushuPlay: false,
            lushuPolyline: null,
            vehicleMarkers: [],
            vehicleMarkersMap: {},
        };
    },
    props: {
        zoom: {
            type: Number,
            default: 9, // 市级
        },
        centerLatLng: {
            type: Object,
            default: () => ({
                // lng: 118.620816,
                // lat: 24.890417,
                lng: 118.865842,
                lat: 25.169908,
            }),
            // default: undefined,
        },
        lushuData: {
            type: Object,
            default: () => null,
        },
        vehicleList: {
            type: Array,
            default: () => [],
        },
        coordinateType: {
            type: String,
            default: 'wgs84', // gcj02;wgs84
        },
        viewportShow: {
            type: Array,
            default: null,
        },
        showDistanceTool: {
            type: Boolean,
            default: null,
        },
        showDrawingManager: {
            type: [Boolean, Array],
            default: false,
        },
        drawingManagerEnableEditing: {
            type: Boolean,
            default: false,
        },
        showMapType: {
            type: Boolean,
            default: null,
        },
    },
    computed: {
        speed() {
            const { lushuData } = this;
            return (lushuData || {}).speed || 5000;
        },
        autoView() {
            const { lushuData } = this;
            return (lushuData || {}).autoView || false;
        },
        lushuPathIcon() {
            const { lushuData } = this;
            let { icon } = lushuData || {};
            if (!icon) {
                icon = vehicleIcon;
                // icon = 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png';
            }
            return {
                url: icon,
                size: {
                    width: 60,
                    height: 28,
                },
                opts: {
                    anchor: {
                        width: 30,
                        height: 14,
                    },
                },
            };
        },
        lushuPath() {
            const { lushuData, BMap, map, coordinateType } = this;
            if (!BMap || !map || !lushuData) return [];
            const { points } = lushuData;
            if (!points || !points.length) return [];
            return points.reduce((pre, cur) => {
                const { longitude, latitude } = cur;
                // console.log(`${longitude},${latitude}`);
                let lng = longitude > 180 ? longitude / 1000000 : longitude;
                let lat = latitude > 90 ? latitude / 1000000 : latitude;
                if (coordinateType === 'gcj02') {
                    [lng, lat] = coordtransform.gcj02tobd09(lng, lat);
                } else if (coordinateType === 'wgs84') {
                    const wgs84 = coordtransform.wgs84togcj02(lng, lat);
                    [lng, lat] = coordtransform.gcj02tobd09(wgs84[0], wgs84[1]);
                }
                pre.push(new BMap.Point(lng, lat));
                return pre;
            }, []);
        },
        hasLushu() {
            const { lushuPath } = this;
            return !!(lushuPath && lushuPath.length);
        },
        vehicleMarkersChange() {
            const { vehicleList, coordinateType } = this;
            return Utils.getUniqueId('change-', vehicleList, coordinateType);
        },
        viewportShow_() {
            const { viewportShow, BMap, map, coordinateType } = this;
            if (!BMap || !map || !viewportShow || !viewportShow.length) return [];
            return viewportShow.reduce((pre, cur) => {
                const { longitude, latitude } = cur;
                let lng = longitude > 180 ? longitude / 1000000 : longitude;
                let lat = latitude > 90 ? latitude / 1000000 : latitude;
                if (coordinateType === 'gcj02') {
                    [lng, lat] = coordtransform.gcj02tobd09(lng, lat);
                } else if (coordinateType === 'wgs84') {
                    const wgs84 = coordtransform.wgs84togcj02(lng, lat);
                    [lng, lat] = coordtransform.gcj02tobd09(wgs84[0], wgs84[1]);
                }
                pre.push(new BMap.Point(lng, lat));
                return pre;
            }, []);
        },
    },
    watch: {
        lushuPath: {
            handler() {
                const { hasLushu, lushuPath, BMap, map } = this;
                if (!hasLushu) return;
                map.setViewport(lushuPath);
                if (this.lushuPolyline) {
                    map.removeOverlay(this.lushuPolyline);
                }
                this.lushuPolyline = new BMap.Polyline(lushuPath, {
                    clip: false,
                    geodesic: true,
                    enableEditing: false,
                    strokeColor: '#f00',
                    strokeWeight: 4,
                });
                map.addOverlay(this.lushuPolyline);
                this.lushuPlay = true;
            },
            immediate: true,
        },
        viewportShow_: {
            handler(val) {
                if (!val || !val.length || !this.map) return;
                this.map.setViewport(val, {
                    enableAnimation: false,
                    // margins: [30, 20, 0, 20],
                    // zoomFactor: -1,
                });
                if (this.map.getZoom() > 13) this.map.setZoom(13);
            },
            immediate: true,
        },
        vehicleMarkersChange: {
            handler() {
                this.createVehicleMarkers();
            },
            immediate: true,
        },
    },
    methods: {
        testGetPath(BMap, map) {
            const p1 = new BMap.Point(118.865411, 25.191195);
            const p2 = new BMap.Point(118.958332, 25.197276);
            const driving = new BMap.DrivingRoute(map, {
                renderOptions: { map, autoViewport: true },
            });
            driving.search(p1, p2);
            setTimeout(() => {
                const res = driving.getResults();
                const plan = res.getPlan(0);
                const route = plan.getRoute(0);
                const path = route.getPath();
                const ponitList = path.map(p => {
                    return {
                        latitude: p.lat,
                        longitude: p.lng,
                    };
                });

                console.log(JSON.stringify(ponitList));
            }, 2000);
        },
        onMapReady({ BMap, map }) {
            this.BMap = BMap;
            this.map = map;

            if (this.showMapType) {
                const mapTypeControl = new BMap.MapTypeControl({
                    anchor: global.BMAP_ANCHOR_BOTTOM_LEFT,
                    offset: new BMap.Size(10, 60),
                    type: global.BMAP_MAPTYPE_CONTROL_HORIZONTAL,
                    mapTypes: ['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP'].map(type => global[type]),
                });
                map.addControl(mapTypeControl);
            }

            // this.testGetPath(BMap, map);

            /* const path = [
        new BMap.Point(116.617562, 40.0823),
        new BMap.Point(37.700058, 55.850864),
      ];
      // console.log(BMap, map);
      const polyline = new BMap.Polyline(path, {
        clip: false,
        geodesic: true,
        strokeWeight: 3,
      });

      map.addOverlay(polyline);

      // this.path = polyline.getPath();
      this.path = path;
      console.log(path, polyline, this.path); */
            this.$emit('ready', { BMap, map });
        },
        changeBtnText(val) {
            if (val === 'play_arrow') {
                this.lushuPlay = false;
            }
        },
        toggle() {
            this.lushuPlay = !this.lushuPlay;
        },
        createVehicleMarkers() {
            const { vehicleList, coordinateType, vehicleMarkersMap } = this;
            this.vehicleMarkers = (vehicleList || []).map(item => {
                const { longitude, latitude, direction } = item;
                let lng = longitude > 180 ? longitude / 1000000 : longitude;
                let lat = latitude > 90 ? latitude / 1000000 : latitude;
                if (coordinateType === 'gcj02') {
                    [lng, lat] = coordtransform.gcj02tobd09(lng, lat);
                } else if (coordinateType === 'wgs84') {
                    const wgs84 = coordtransform.wgs84togcj02(lng, lat);
                    [lng, lat] = coordtransform.gcj02tobd09(wgs84[0], wgs84[1]);
                }

                const oldData = vehicleMarkersMap[item.id] || {};
                console.log(item.id, oldData, item, direction);
                const data = {
                    ...item,
                    longitude: lng,
                    latitude: lat,
                    icon: this.lushuPathIcon,
                    rotation: direction - 90,
                    infoWindowData: {
                        ...item,
                        ...(item.infoWindowData || {}),
                    },
                    infoWindowShow: !!oldData.infoWindowShow,
                    // label: 'label',
                };
                this.$set(vehicleMarkersMap, item.id, data);
                return data;
            });
        },
        onMarker(marker, index, val) {
            console.log(marker);
            const { vehicleMarkers, vehicleMarkersMap } = this;
            if (!marker.infoWindowData) return;
            const data = {
                ...marker,
                infoWindowShow: Utils.isDef(val) ? !!val : !marker.infoWindowShow,
            };
            vehicleMarkers.splice(index, 1, data);
            this.$set(vehicleMarkersMap, data.id, data);
        },
        // 导出方法
        getDrawData() {
            const { $refs } = this;
            const { bMapDrawingManager } = $refs;
            if (!bMapDrawingManager) return [];
            return bMapDrawingManager.getDrawData();
        },
        setDrawData(data) {
            const { $refs } = this;
            const { bMapDrawingManager } = $refs;
            if (!bMapDrawingManager) return null;
            return bMapDrawingManager.setDrawData(data);
        },
    },
};
</script>

<style lang="scss">
.monitor-map {
    height: 700px;

    > .map {
        width: 100%;
        height: 100%;

        .bm-control {
            left: 0;
            top: 0;
            right: 0;
            inset: 0 0 auto 0 !important;
            pointer-events: none;
            padding: $padding;

            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;

            > .left-wrap {
                pointer-events: auto;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
            }

            > .right-wrap {
                pointer-events: auto;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }
    }
}
</style>
